import React from "react";
import { Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";
import { Close } from "@mui/icons-material";

const PopupError = ({ closePopupError, copyError }) => {
  return (
    <Grid container style={{ backgroundColor: "#fff" }}>
      <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
        <Grid xs={1} item>
          {" "}
          <div className="icon-error-message" />
        </Grid>
        <Grid xs={10} item>
          {" "}
          <Typography
            sx={{ marginLeft: "10px", fontSize: { xs: "14px", sm: "16px" } }}
          >
            {copyError}
          </Typography>
        </Grid>
        <Grid xs={1} item>
          {" "}
          <div
            style={{
              marginLeft: "10px",
              display: "flex",
              alignItems: "center",
              marginTop: "2px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              closePopupError();
            }}
          >
            <Close style={{ color: "#5b5b5b" }} fontSize="small" />
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PopupError;
